module.exports = __webpack_public_path__ + "img/schwalm_logo.005af7d6.svg";